/** Map Moyasar raw error messages to user-friendly text */
export function formatPaymentError(raw: string): string {
  const normalized = raw.toUpperCase();

  if (normalized.includes('CARD COUNTRY NOT ALLOWED') || normalized.includes('CARD_COUNTRY')) {
    return 'Please use a Saudi-issued card or call us to confirm your reservation.';
  }

  if (normalized.includes('INSUFFICIENT_FUNDS') || normalized.includes('INSUFFICIENT FUNDS')) {
    return 'Insufficient funds. Please try a different card.';
  }

  if (normalized.includes('EXPIRED') || normalized.includes('CARD_EXPIRED')) {
    return 'This card has expired. Please use a different card.';
  }

  if (normalized.includes('BLOCKED') && !normalized.includes('CARD COUNTRY')) {
    return 'This card has been blocked. Please try a different card.';
  }

  return raw;
}

/** Safely call session.completePayment -- Safari 26+ throws TypeError */
export function safeCompletePayment(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Apple Pay session has no TS types
  session: any,
  status: number,
) {
  try {
    session.completePayment({ status });
  } catch {
    // Silently ignore -- the Apple Pay sheet will close regardless
  }
}
